import React, { useReducer } from 'react'
import Autocomplete from 'react-autocomplete'
import * as S from './styles'

type ObjProps = {
  value: number
  label: string
}
type Props = {
  options: Array<ObjProps>
  labelColor: string
  name: string
  label: string
  onMenuClose?: any
  onSelect?: any
  valueInitial?: string
  setValue: any
  wrapperClassName?: string
}

const MyAutoComplete = ({
  options,
  labelColor,
  name,
  label,
  onSelect,
  valueInitial,
  setValue,
  wrapperClassName
}: Props) => {
  const initialState = valueInitial
  const reduceUser = (state: any, action: any) => {
    switch (action) {
      case undefined:
        return ''
        break
      default:
        return action
    }
  }
  const [newValue, dispatch] = useReducer(reduceUser, initialState)
  return (
    <S.Wrapper className={wrapperClassName}>
      <label style={{ color: labelColor }} htmlFor={name}>
        {label}
      </label>
      <Autocomplete
        items={options}
        shouldItemRender={(item: any, val: any) => {
          return item.label.toLowerCase().indexOf(val.toLowerCase()) > -1
        }}
        selectOnBlur={false}
        getItemValue={(item: any) => item.label}
        menuStyle={S.MenuStyle}
        wrapperStyle={S.WrapperAutocomplete}
        renderItem={(item: any, highlighted: any) => (
          <div
            key={item.value}
            style={{
              backgroundColor: highlighted ? '#0875f1' : 'transparent',
              ...S.MenuItemStyle,
              color: highlighted ? '#eaeaee' : '#000000'
            }}
          >
            {item.label}
          </div>
        )}
        value={newValue}
        onChange={(e: any) => {
          dispatch(e.target.value)
          setValue(e.target.value)
        }}
        onSelect={(val: any, item: any) => {
          onSelect(item.value)
          dispatch(val)
        }}
      />
    </S.Wrapper>
  )
}
export default MyAutoComplete
